// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"3f085f0b","130":"9fe89706","149":"c0a1ed3b","156":"f699d5ca","181":"554a9542","283":"0adfc2f7","372":"4e269311","378":"8a6d6f19","408":"c9e9927c","437":"1df7d619","596":"ce835a5a","789":"03e63f03","839":"e81c9778","942":"435bd299"}[chunkId] + ".chunk.js";
};